import { render, staticRenderFns } from "./StickerPreview.vue?vue&type=template&id=bbb677ac&"
import script from "./StickerPreview.vue?vue&type=script&lang=js&"
export * from "./StickerPreview.vue?vue&type=script&lang=js&"
import style0 from "./StickerPreview.vue?vue&type=style&index=0&id=bbb677ac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports